import React from "react";
import { useTranslation } from "react-i18next";
import { Select, SelectOption, Typography } from '@launchmetrics/lm-ui';

import { useReportSettings } from "../../hooks";
import { CURRENCIES } from "../consts";
import { ReportCurrency } from "store/ui/report/types";
import { useSelector } from "react-redux";
import { State } from "store/types";

export const Currency: React.FC = () => {

	const disabled = useSelector((state: State) => state.article.report.formDisabled);

	const { t } = useTranslation();
	const [reportSettings, setReportSettings] = useReportSettings();

	return (
		<div className='side-panel-content-entry-element'>
			<div><Typography variant='textXsMedium' styleProps={{ color: disabled? 'text.disabled' : undefined }}>{t('reports.currency')}</Typography></div>
			<div>
				<Select
					id="report-currency"
					defaultValue={{ key: t(`reports.currency_${reportSettings.currency}`), value: t(`reports.currency_${reportSettings.currency}`) as string }}
					onChange={value => setReportSettings({currency: value.key as ReportCurrency})}
					disabled={disabled}
				>
					{CURRENCIES.map((currency, index) => (
						<SelectOption
							id={`report-currency-${currency}`}
							selected={reportSettings?.currency === currency}
							key={index}
							optionValue={{ key: currency, value: t(`reports.currency_${currency}`) as string }}
						/>
					))}
				</Select>
			</div>
		</div>
	);
};
